import React from 'react';
import { observer } from "mobx-react-lite";
import { Layout } from "../modules/Layout";
import Dictionaries from '../modules/Secure';

export const SecurePage = observer(() => {
    return (
        <Layout offset={{left: 1}}>
            <Dictionaries/>
        </Layout>
    )
});